module.exports = __webpack_public_path__ + "static/background-7d94d2352cd0942a7683c774258397e8.png";